import { render } from "./RiDeco2.vue?vue&type=template&id=31c3ef28"
import script from "./RiDeco2.vue?vue&type=script&lang=js"
export * from "./RiDeco2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiDeco2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31c3ef28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31c3ef28', __exports__)) {
    api.reload('31c3ef28', __exports__)
  }
  
  module.hot.accept("./RiDeco2.vue?vue&type=template&id=31c3ef28", () => {
    api.rerender('31c3ef28', render)
  })

}


export default __exports__